module.exports = "<form style=\"margin-bottom: 20px;\">\r\n  <div class=\"input-group\">\r\n    <span class=\"input-group-addon\"><i class=\"fa\" class=\"fa fa-search\"></i></span>\r\n    <input #searchInput type=\"text\" class=\"form-control\" id=\"search\" name=\"search\" [placeholder]=\"searchTextPlaceHolder\" [value]=\"searchText\">\r\n  </div>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+admin/modules/display/search/search.component.html
// module id = 1156
// module chunks = 0